import script from "./Editable.vue?vue&type=script&setup=true&lang=js"
export * from "./Editable.vue?vue&type=script&setup=true&lang=js"

import "./Editable.vue?vue&type=style&index=0&id=7944879b&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7944879b"]])

export default __exports__